import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import s from "./textArea.scss";

export default class TextArea extends React.Component {
  updateValue(e) {
    const value = e.currentTarget.value;
    this.props.onChange({ [this.props.name]: value });
  }

  render() {
    const {
      className,
      hint,
      errors,
      onlyRead,
      disabled,
      hasLabel,
      noLabel,
      required,
      value
    } = this.props;
    let label = this.props.label;
    // if it is an hidden input, hide the label
    if (this.props.type === "hidden") {
      label = "";
    }

    // let inputWLabelClasses = 'input-wlabel '
    // if (disabled) {
    //   inputWLabelClasses = inputWLabelClasses + 'disabled '
    // }
    // if (errors) {
    //   inputWLabelClasses = inputWLabelClasses + ' w-errors '
    // }

    // if (hasLabel === false) {
    //   inputWLabelClasses = 'input-no-label'
    // }

    const optionalLogo = required ? (
      ""
    ) : (
      <span className="optional-logo">&nbsp;&nbsp;optional</span>
    );

    return (
      <div
        className={cx(s.inputContainer, className, {
          [s.labelHint]: hint,
          [s.withErrors]: errors,
          [s.onlyRead]: onlyRead,
          [s.disabled]: disabled
        })}
      >
        {!noLabel && (
          <div className={s.wrapLabel}>
            <label className={s.label} htmlFor="name">
              {label}
            </label>
            {hint && <div className={s.hint}>{hint}</div>}
          </div>
        )}

        <textarea
          className={s.input}
          required={this.props.required}
          readOnly={onlyRead}
          disabled={this.props.status === "disabled" || this.props.disabled}
          rows={this.props.rows}
          cols={this.props.cols}
          onChange={this.updateValue.bind(this)}
          value={value}
        />
      </div>
    );
  }
}
